var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$can('VIEW_ALL_PRODUCT_SUBFAMILY'))?_c('sub-families',{attrs:{"familyId":_vm.$route.params.id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }